import React, { useState } from 'react';
import { getAuth, sendSignInLinkToEmail } from "firebase/auth";

const EmailRegistration = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSendLink = async () => {
    const auth = getAuth();
    const actionCodeSettings = {
      url: 'http://localhost:3000/signup', // 新規登録画面のURL
      handleCodeInApp: true,
    };

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      setMessage('認証リンクが送信されました。メールを確認してください。');
    } catch (error) {
      setMessage('リンクの送信に失敗しました: ' + error.message);
    }
  };

  return (
    <div>
      <h1>メールアドレス登録</h1>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="メールアドレスを入力してください"
      />
      <button onClick={handleSendLink}>認証リンクを送信</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default EmailRegistration;
